import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import useQuery from '../../../../shared/hooks/useQuery';
import { useSelectedOrganization } from '../../../../shared/hooks/use-organizations';
import { rdsChatCountEnabledOrgsAtom } from '../states/chat-list';
import { getRdsChatCountEnabledOrgs } from '../requests/get-chat';

export const useInternalOrgs = () => {
  const currentOrg = useSelectedOrganization();
  const currentOrgId = currentOrg?.orgId;

  const getRdsChatCountEnabledOrgsGetter = useCallback(async () => {
    const response = await getRdsChatCountEnabledOrgs();
    return response;
  }, []);

  const {
    requestData: { data: rdsChatCountEnabledOrgsData },
  } = useQuery<{ orgIds: string[] }>({
    requestAtom: rdsChatCountEnabledOrgsAtom,
    queryFunction: getRdsChatCountEnabledOrgsGetter,
    cacheData: true,
    autoFetch: true,
  });

  const isInternalOrg = useCallback(
    (orgId?: string): boolean => {
      if (!orgId || !rdsChatCountEnabledOrgsData?.orgIds) {
        return false;
      }
      return rdsChatCountEnabledOrgsData.orgIds.includes(orgId);
    },
    [rdsChatCountEnabledOrgsData]
  );

  const isInternal = isInternalOrg(currentOrgId);

  return {
    isInternal,
    isInternalOrg,
    orgIds: rdsChatCountEnabledOrgsData?.orgIds ?? [],
    loading: !rdsChatCountEnabledOrgsData,
  };
};
